import { Component } from '@angular/core';

@Component({
  selector: 'app-leads-reports',
  imports: [],
  templateUrl: './leads-reports.html',
  styleUrl: './leads-reports.scss'
})
export class LeadsReports {

}
